import { render } from "./CustomCategoryLinkedParticipantListView.vue?vue&type=template&id=048b1137&ts=true"
import script from "./CustomCategoryLinkedParticipantListView.vue?vue&type=script&lang=ts"
export * from "./CustomCategoryLinkedParticipantListView.vue?vue&type=script&lang=ts"

import "./CustomCategoryLinkedParticipantListView.vue?vue&type=style&index=0&id=048b1137&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__